export default function(url, data = {}) {
  if (url == null) {
    return
  }

  return $.ajax({
    url: url.replace('/post?', '/post-json?').concat('&c=?'),
    data: data,
    dataType: 'jsonp',
  })
}



// WEBPACK FOOTER //
// ./ajax-chimp.js